<script lang="ts">
    import lang from '../../lang/language';
    import type { ServiceType } from '../../store/types';
    import { formatMoney, getType } from '../../helpers/common';
    import AddToWishlistButton from '../../shared_components/AddToWishlistButton.svelte';
    import { getDetailsUrl, getLanguage } from '../../helpers/url';
    import { currentLangIsJapanese } from '../../helpers/url';
    // import { Link } from 'svelte-navigator';

    import { link } from 'svelte-spa-router';

    export let service: any;
</script>

<!-- <div class="col-md-4 mb-4">
    <div class="card-wrapper c-card">
        <div class="thumb-wrapper">
            <img
                src={service.Thumbnail}
                alt="service thumbnail"
                class=" background-animate"
            />
        </div>
        <h4 class="info name my-3">{service.Name}</h4>
        <div class="" style="border-bottom: 1px solid black; margin: 10px 0" />
        <div class="info address">{service.Address}</div>

        <div class="info price">
            {#if service.Price}
                {!currentLangIsJapanese() && service.Price > 0 ? lang.from : ''}
                ¥{formatMoney(service.Price)}
                {currentLangIsJapanese() && service.Price > 0 ? lang.from : ''}
            {/if}
        </div>
        <div class="info desc">
            {@html service.Desc}
        </div>

        <a href="" class="">
            <div class="cardMore">
                <span class="c-button-detail">{lang.view_details} 〉</span>
            </div>
        </a>
    </div>
</div> -->
<li class="planBox">
    <a
        href="?lang={getLanguage()}&page=details&id={service.Id}&on_req={service.OnRequestOnly}"
    >
        <div class="planBox__ph">
            <p
                style="background: transparent url({service.Thumbnail}) no-repeat center center; background-size: cover;"
            >
                <img src={service.Thumbnail} alt={service.Name} />
            </p>
        </div>
        <div class="planBox__content">
            <div class="planBox__textarea">
                <p class="planBox__ttl">
                    {service.Name}
                </p>
                <p class="planBox__plan">{getType(service.Type)}</p>
                <p class="planBox__desc info desc services">
                    {@html service.Desc}
                </p>
                <p class="planBox__price">
                    {#if service.Price}
                        <span class="from"
                            >{!currentLangIsJapanese() && service.Price > 0
                                ? lang.from
                                : ''}</span
                        ><span class="price">{formatMoney(service.Price)}</span
                        ><span class="jpy">JPY</span>
                        <span
                            >{currentLangIsJapanese() && service.Price > 0
                                ? lang.from
                                : ''}</span
                        >
                    {/if}
                </p>
            </div>
            <!-- <div class="planBox__detail month">
                          <p>MAY/JUN/JUL/AUG/SEP</p>
                      </div>
                      <div class="planBox__detail category">
                          <p>CUSTOM TRAVEL THEME</p>
                      </div> -->
        </div>
    </a>
</li>

<style>
    .full-width {
        width: 100%;
    }

    .planBox__ph p {
        height: 280px;
        width: 100%;
    }

    .planBox__ph img {
        height: 280px;
        width: 100%;
        object-fit: cover;
    }

    :global(.card-wrapper) {
        background-color: transparent;
        padding: 5px;
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
        position: relative;
        background-color: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(5px);
    }

    :global(.thumb-wrapper) > :global(img) {
        background-color: black;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    :global(.thumb-wrapper) {
        border: 1px solid lightgray;
        width: 100%;
        height: 200px;
    }

    :global(.thumb-wrapper.children) {
        border: 1px solid lightgray;
        width: 100%;
        height: 100%;
    }

    :global(.info) {
        margin: 5px 0px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        height: 20px;
        line-height: 20px;
        color: black;
        text-align: left;
    }

    :global(.info.name) {
        font-weight: bold;
    }

    :global(.info.desc) {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        height: 60px;
        line-height: 20px;
        position: relative;
    }

    :global(.info.desc.children) {
        -webkit-line-clamp: inherit;
        height: auto;
    }

    :global(.info.address) {
        background-image: url('../icons/pin.png');
        background-size: 15px;
        background-position: left center;
        padding-left: 15px;
        background-repeat: no-repeat;
    }
    :global(.info.address) {
        background-image: url('../icons/rating.png');
        background-size: 15px;
        background-position: left center;
        padding-left: 15px;
        background-repeat: no-repeat;
    }

    :global(.row-button) {
        display: flex;
        width: 100%;
        text-align: center;
        overflow: hidden;
        height: auto;
        padding: 20px 10px;
    }

    :global(.col-button) {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;
        text-align: center;
        overflow: hidden;
        height: auto;
        padding: 20px 10px;
    }

    :global(.card-wrapper) a {
        text-decoration: none;
        font-weight: bold;
    }

    :global(.like-button-wrapper) {
        position: absolute;
        top: 15px;
        right: 10px;
    }
</style>
